import { getQueryParams } from "@/utils/httpRequest";
import { loanService } from "@/modules/loan/store/services/loan-service";

const getLoans = loanService.injectEndpoints({
  endpoints: builder => ({
    getLoans: builder.query({
      query: params => `loans?${getQueryParams(params)}`,
      providesTags: [{ type: "Loan", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoansQuery } = getLoans;

